import React from 'react';
import styles from './ProgressRing.module.css';

interface ProgressRingProps {
  percent: number;       // 0-100
  size?: number;         // 直径 px，默认 80
  strokeWidth?: number;  // 环宽度，默认 6
  color?: string;        // 进度色，默认 #4caf50
  label?: string;        // 中心文字
  sublabel?: string;     // 中心小字
}

const ProgressRing: React.FC<ProgressRingProps> = ({
  percent,
  size = 80,
  strokeWidth = 6,
  color = '#4caf50',
  label,
  sublabel,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  const center = size / 2;

  return (
    <div className={styles.container} style={{ width: size, height: size }}>
      <svg width={size} height={size} className={styles.svg}>
        {/* 背景圆环 */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#e8e0d9"
          strokeWidth={strokeWidth}
        />
        {/* 进度圆环 */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={styles.progress}
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <div className={styles.label}>
        {label !== undefined ? (
          <>
            <span className={styles.percentText}>{label}</span>
            {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
          </>
        ) : (
          <>
            <span className={styles.percentText}>{percent}%</span>
            {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
          </>
        )}
      </div>
    </div>
  );
};

export default ProgressRing;
